<section class="print-subscription-panel">
  <div class="vt-border rounded-10 users-container mb-3 bg-white">
    <div class="px-3 py-3 row">
      <div class="col-lg-4 user-col" *ngFor="let row of settingTilesData">
        <div class="px-2">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-start flex-md-row flex-column">
              <h3 class="font-fraunces fw-semibold heading">{{row.label}}</h3>
            </div>
            <i class="icon-multiple-user fs-3 rounded-10 p-2"></i>
            </div>
            <div class="d-flex  main-card-content">
              <div>
                <p class="font-dm count text-dark-green mt-2 pt-1">{{row.count}}</p>
                <p class="font-fraunces fs-6">Current subs</p>
              </div>
              <div>
                <p class="font-dm count text-dark-green mt-2 pt-1">{{row.threshold}}</p>
                <p class="font-fraunces fs-6">Max subs</p>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="card">
  <h3 class="card-title mb-0">Print Subscription List</h3>
  <Datatable [url]="url" [colDefs]="colDefs" [exportFilter]="false"></Datatable>
</div>


